<template>
  <div class="return_detail_wrapper">
    <div class="header">
      <div>
        <a-button icon="arrow-left" size="small" @click="() => $router.back()" />
        <span class="page_type">详情</span>
      </div>
    </div>
    <div class="content">
      <div class="common flex-row">
        <div class="left">
          <div class="basic-info">
            <div class="img-wrapper">
              <a-avatar shape="square" :size="26" :src="titlePrefix" />
            </div>
            <div>
              <div class="code">
                <span style="display: inline-block; width: 15em;">退货单号：{{ detailInfo.afterCode }}</span>
                <span :class="`status-${detailInfo.refundState}`">
                {{ convertToName(refundStateGroup, detailInfo.refundState) }}
                </span>
              </div>
              <div class="customer">{{ detailInfo.unit }}</div>
            </div>
          </div>
          <a-tabs default-active-key="1" @change="handleActiveChange">
            <a-tab-pane key="1" tab="退货信息">
            </a-tab-pane>
            <a-tab-pane key="2" tab="日志动态">
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
      <template v-if="activeKey === '1'">
        <div class="common">
          <div class="title gap-12">基本信息</div>
          <el-descriptions :column="3">
            <el-descriptions-item label="销售合同编号">{{
              detailInfo.pcCode | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="销售订单号">{{
              detailInfo.orderCode | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="售后申请单号">{{
              detailInfo.afterCode | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="客户抬头">{{
              detailInfo.unit | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="客户联系人">{{
              detailInfo.salesmanName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="联系人电话">{{
              detailInfo.salesmanPhone | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="售后类型">{{
              detailInfo.typeName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="售后原因">{{
              detailInfo.reason | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="售后申请状态">{{
              detailInfo.stateName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item v-if="[4, '4'].includes(detailInfo.state)" label="驳回原因">{{
              detailInfo.supIdea | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="退货收货信息">{{
              detailInfo.detailAddress | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="售后创建时间">{{
              detailInfo.createTime | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="备注">{{
              detailInfo.remark | setEmpty
            }}</el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="common">
          <div class="title gap-12">退货信息</div>
          <template v-if="detailInfo.goodsSerialList && detailInfo.goodsSerialList.length">
            <div v-for="(logostics, index) in detailInfo.goodsSerialList" :key="'logostics-'+index">
              <div class="logostics-box">
                <img @click="showOpenSubTable(logostics, index)" :src="logostics.show ? require('@/assets/icon_open.svg') : require('@/assets/icon_close.svg')" class="icon" />
                <div @click="showOpenSubTable(logostics, index)" class="company">{{ logostics.logisticsCompany }}</div>
                <div class="info">
                  物流单号<span @click="handleShowExpressDialog(logostics)" class="value" style="color: #5195eb;cursor: pointer;">{{ logostics.logisticsCode }}</span>
                </div>
                <div class="info">
                  物流状态<span class="value">{{ convertToName(logisticsStatusOptions, logostics.logisticsState, detailInfo.directType) }}</span>
                </div>
              </div>
              <div v-if="logostics.goodsSerialDetailList && logostics.goodsSerialDetailList.length" style="width: 100%;overflow: scroll;">
                <a-table
                  v-if="logostics.show"
                  :columns="columnList"
                  :data-source="logostics.goodsSerialDetailList"
                  :pagination="false"
                  rowKey="id"
                  size="small"
                  class="subTable"
                  style="margin-bottom: 10px; min-width: 2000px;">
                  <template slot="imageList" slot-scope="image">
                    <span v-if="image && image.split(',').length > 0">
                      <span v-for="(img, i) in image.split(',')" :key="'img-'+i">
                        <el-image v-if="i < 2" style="width: 32px; height: 32px; margin-right: 5px;" :src="img" :preview-src-list="image.split(',')" />
                      </span>
                      <span v-if="image.split(',').length > 2" style="color:#3182bd; margin-left: 2px;">...</span>
                    </span>
                    <span v-else>暂无图片</span>
                  </template>
                  <template slot="footer" slot-scope="currentPageData">
                    <div>
                      <b style="margin-right: 100px;">合计</b>
                      <b style="margin-right: 5px;">数量：{{ logostics.goodsSerialDetailList.length }}</b>
                      <b>，总金额：{{ currentPageData.reduce((pre, cur) => pre + cur.purchPrice, 0).toLocaleString('en-US', { minimumFractionDigits: 2 }) || '-' }}</b>
                    </div>
                  </template>
                </a-table>
              </div>
              <a-empty v-else :image="require('@/assets/empty.svg')" description='暂无数据'></a-empty>
            </div>
          </template>
          <Empty v-else />
        </div>
      </template>
      <template v-if="activeKey === '2'">
        <div class="common" style="padding-top: 0;">
          <xz-table ref="xzTable" :columns="logColumns" :data="logData" rowKey="id"></xz-table>
        </div>
      </template>
    </div>

    <ExpressDialog ref="expressDialogRef" />
  </div>
</template>
<script>
import * as Moment from 'dayjs';
import { details } from '@/api/service';
import setTableCols from './configs';
import { logTypes } from '@/model/logTypes';
import { queryLogListById } from '@/api/saleContract';
import { logisticsStatusOptions } from '@/model/serviceReturns';
import ExpressDialog from '@/components/expressDialog.vue';
import Empty from '@/components/empty.vue';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';

const refundStateGroup = [
  { label: '待收货', value: 1 },
  { label: '已收货', value: 2 },
  { label: '部分收货', value: 3 },
];

export default {
  name: 'return_detail',
  components: {
    Empty,
    ExpressDialog,
    xzTable,
  },
  props: {
    id: {
      type: String,
    },
  },
  filters: {
    setEmpty (val) {
      return val ? val : '--';
    },
  },
  data () {
    return {
      titlePrefix: require('@/assets/title_prefix.svg'),
      activeKey: '1',
      refundStateGroup,
      logisticsStatusOptions,
      detailInfo: {
        goodsSerialList: [],
      },
      columnList: setTableCols.call(this, 'detail'),
      logData: [],
      logColumns: [
        {
          title: '事件类型',
          dataIndex: 'logType',
          key: 'logType',
          width: 300,
          customRender: (text) => {
            let val = '--';

            for (let v of logTypes) {
              if (v.value === text) {
                val = v.label;
                break;
              }
            }

            return val;
          },
        },
        {
          title: '时间',
          dataIndex: 'createTime',
          key: 'createTime',
          width: 300,
          customRender: (text) => {
            return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
          },
        },
        {
          title: '日志内容',
          dataIndex: 'content',
          key: 'content',
        },
      ],
    };
  },
  created () {
    this.getDetail();
    this.getLog();
  },
  methods: {
    convertToName (enums, value, type) {
      let title = '--';
      const _value = type === 1 ? value - 1 : value; // 1-直发 2-非直发

      for (let v of enums) {
        if (Number(v.value) === Number(_value)) {
          title = v.label;
          break;
        }
      }

      return title;
    },
    handleActiveChange (v) {
      this.activeKey = v;
    },
    showOpenSubTable (row, i) {
      // this.detailInfo.goodsSerialList[i].show = !this.detailInfo.goodsSerialList[i].show;
      this.$set(this.detailInfo.goodsSerialList[i], 'show', !this.detailInfo.goodsSerialList[i].show);
    },
    getDetail () {
      details({ id: this.id }).then(({ body }) => {
        if (body.directType === 2) {
          body.goodsSerialList = body.goodsSerialList || [];
        }

        body.typeName
          = body.type === 1
            ? '仅退货'
            : body.type === 2
              ? '仅退款'
              : body.type === 3
                ? '退货退款'
                : '';
        body.stateName
          = body.state === 1
            ? '待审核'
            : body.state === 2
              ? '售后处理中'
              : body.state === 3
                ? '已完成'
                : body.state === 4
                  ? '已驳回'
                  : body.state === 5
                    ? '已关闭'
                    : '';

        body.detailAddress = `${body.provinceName || ''}${body.cityName || ''}${
          body.areaName || ''
        }${body.address || ''}`;

        body.goodsSerialList = body.goodsSerialList || [];

        if (!body.goodsSerialList.length) {
          body.goodsSerialList = [];
        }

        this.detailInfo = body;
      });
    },
    handleShowExpressDialog (logostics) {
      this.$refs.expressDialogRef.transportCode = logostics.logisticsCode;
      this.$refs.expressDialogRef.info = logostics;
      this.$refs.expressDialogRef.dialogVisible = true;
    },
    getLog () {
      queryLogListById({
        id: this.id,
      }).then(({ body }) => {
        this.logData = body || [];
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: normal;
}
.return_detail_wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;

  .header {
    height: 52px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;

    .page_type {
      font-size: 16px;
      font-weight: bold;
      margin-left: 1em;
    }
  }

  .content {
    flex: 1;
    padding: 8px 0 0;
    overflow: auto;

    .gap-12 {
      margin-bottom: 12px;
    }

    .common {
      background-color: #fff;
      padding: 12px;
      margin-bottom: 6px;

      &.flex-row {
        display: flex;
        justify-content: space-between;
        padding-right: 0;
        padding-bottom: 0;

        .left {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .basic-info {
            display: flex;
            align-items: center;

            .img-wrapper {
              width: 40px;
              height: 40px;
              background-color: #E2F3FE;
              border-radius: 4px;
              margin-right: 6px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .code {
              font-size: 14px;
              color: #929AA6;

              .status-3 {
                @include tag_round();
                background-color: #E2F3FE;
                color: #237FFA;
              }

              .status-2 {
                @include tag_round();
                background-color: #E5FEEB;
                color: #14CA64;
              }

              .status-1 {
                @include tag_round();
                background-color: #FEFEE5;
                color: #FAB007;
              }
            }

            .customer {
              font-size: 16px;
              font-weight: 600;
            }
          }

          /deep/ .ant-tabs-bar {
            margin: 0;

            .ant-tabs-nav {
              .ant-tabs-tab {
                margin-right: 16px;
              }
            }
          }
        }
      }

      .title {
        font-weight: bold;
      }
    }
  }

  .logostics-box {
    padding-top: 5px;
    padding-bottom: 15px;
    display: flex;
    .icon {
      width: 16px;
      height: 16px;
      margin-right: 8px;
      cursor: default;
    }
    .company {
      font-weight: 600;
      font-size: 14px;
      color: #1F2733;
      width: 250px;
      cursor: default;
    }
    .info {
      font-weight: 400;
      font-size: 14px;
      color: #929AA6;
      width: 300px;
      .value {
        font-weight: 400;
        font-size: 14px;
        color: #1F2733;
        margin-left: 12px;
      }
    }
  }
}
</style>
